import { apiClient, API_PRX } from '@indipia/shared';

export interface WorkType {
  workTypeId: number;
  workTypeCode: string;
  workTypeName: string;
  sortOrder: number;
}

export async function fetchWorkTypes(): Promise<WorkType[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/work-types`);
  return (res.data.data ?? []) as WorkType[];
}

export interface CommonCode {
  codeValue: string;
  codeName: string;
}

/** 공통코드 그룹 조회 (예: E01_PARTNER_TYPE) */
export async function fetchCommonCodes(codeGroupCode: string): Promise<CommonCode[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/codes`, { params: { codeGroupCode } });
  return (res.data.data ?? []) as CommonCode[];
}
